var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pricingTable" }, [
    _c("div", { staticClass: "pricingTable_row" }, [
      _c("span", [
        _vm._v(
          _vm._s(_vm.booking.name) +
            " " +
            _vm._s(_vm.$showTax ? "(incl. tax)" : "")
        ),
      ]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          _vm._s(_vm._f("currency")(_vm.paymentAmount, _vm.booking.currency))
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.cardSurcharge
      ? _c("div", { staticClass: "pricingTable_row surcharge_row" }, [
          _c("span", [_vm._v("Card surcharge")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              _vm._s(
                _vm._f("currency")(_vm.cardSurcharge, _vm.booking.currency)
              )
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "pricingTable_row pricingTable_totals" }, [
      _c("span", [_vm._v("Your total")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          _vm._s(
            _vm._f("currency")(_vm.totalPaymentAmount, _vm.booking.currency)
          )
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }